export default [
  // {
  //   featureType: 'administrative',
  //   elementType: 'labels.text.fill',
  //   stylers: [
  //     {
  //       color: '#fefdfe',
  //     },
  //   ],
  // },
  // {
  //   featureType: 'administrative',
  //   elementType: 'labels.text.stroke',
  //   stylers: [
  //     {
  //       color: '#1f1a2d',
  //     },
  //   ],
  // },
  // {
  //   featureType: 'landscape',
  //   elementType: 'geometry.fill',
  //   stylers: [
  //     {
  //       color: '#a061ea',
  //     },
  //   ],
  // },
  // {
  //   featureType: 'landscape',
  //   elementType: 'labels',
  //   stylers: [
  //     {
  //       color: '#fffefa',
  //     },
  //   ],
  // },
  // {
  //   featureType: 'landscape',
  //   elementType: 'labels.text.stroke',
  //   stylers: [
  //     {
  //       color: '#000000',
  //     },
  //   ],
  // },
  // {
  //   featureType: 'landscape.man_made',
  //   elementType: 'geometry.fill',
  //   stylers: [
  //     {
  //       color: '#a061ea',
  //     },
  //   ],
  // },
  // {
  //   featureType: 'landscape.natural',
  //   elementType: 'geometry.fill',
  //   stylers: [
  //     {
  //       color: '#a061ea',
  //     },
  //   ],
  // },
  // {
  //   featureType: 'poi',
  //   elementType: 'geometry.fill',
  //   stylers: [
  //     {
  //       color: '#b59ce6',
  //     },
  //   ],
  // },
  // {
  //   featureType: 'poi',
  //   elementType: 'labels.icon',
  //   stylers: [
  //     {
  //       color: '#0fbdfe',
  //     },
  //   ],
  // },
  // {
  //   featureType: 'poi',
  //   elementType: 'labels.text.fill',
  //   stylers: [
  //     {
  //       color: '#ffffff',
  //     },
  //   ],
  // },
  // {
  //   featureType: 'poi',
  //   elementType: 'labels.text.stroke',
  //   stylers: [
  //     {
  //       color: '#1d1630',
  //     },
  //   ],
  // },
  // {
  //   featureType: 'poi.park',
  //   elementType: 'geometry.fill',
  //   stylers: [
  //     {
  //       color: '#b59ce6',
  //     },
  //   ],
  // },
  // {
  //   featureType: 'road',
  //   elementType: 'geometry.fill',
  //   stylers: [
  //     {
  //       color: '#6851ae',
  //     },
  //   ],
  // },
  // {
  //   featureType: 'road',
  //   elementType: 'labels.text',
  //   stylers: [
  //     {
  //       color: '#eee3f9',
  //     },
  //   ],
  // },
  // {
  //   featureType: 'road.highway',
  //   elementType: 'geometry.fill',
  //   stylers: [
  //     {
  //       color: '#6c427e',
  //     },
  //   ],
  // },
  // {
  //   featureType: 'road.highway',
  //   elementType: 'geometry.stroke',
  //   stylers: [
  //     {
  //       color: '#5b299d',
  //     },
  //   ],
  // },
  // {
  //   featureType: 'road.highway',
  //   elementType: 'labels.text.fill',
  //   stylers: [
  //     {
  //       color: '#68949a',
  //     },
  //   ],
  // },
  // {
  //   featureType: 'road.highway',
  //   elementType: 'labels.text.stroke',
  //   stylers: [
  //     {
  //       color: '#0c435c',
  //     },
  //   ],
  // },
  // {
  //   featureType: 'road.highway.controlled_access',
  //   elementType: 'geometry',
  //   stylers: [
  //     {
  //       color: '#5b299d',
  //     },
  //   ],
  // },
  // {
  //   featureType: 'transit',
  //   elementType: 'geometry.fill',
  //   stylers: [
  //     {
  //       color: '#3a2069',
  //     },
  //   ],
  // },
  // {
  //   featureType: 'transit',
  //   elementType: 'geometry.stroke',
  //   stylers: [
  //     {
  //       color: '#3a2069',
  //     },
  //   ],
  // },
  // {
  //   featureType: 'transit',
  //   elementType: 'labels.text',
  //   stylers: [
  //     {
  //       color: '#ffffff',
  //     },
  //   ],
  // },
  // {
  //   featureType: 'transit',
  //   elementType: 'labels.text.fill',
  //   stylers: [
  //     {
  //       color: '#ffffff',
  //     },
  //   ],
  // },
  // {
  //   featureType: 'transit',
  //   elementType: 'labels.text.stroke',
  //   stylers: [
  //     {
  //       color: '#000000',
  //     },
  //   ],
  // },
  // {
  //   featureType: 'water',
  //   elementType: 'geometry',
  //   stylers: [
  //     {
  //       color: '#3a2069',
  //     },
  //   ],
  // },
  // {
  //   featureType: 'water',
  //   elementType: 'geometry.fill',
  //   stylers: [
  //     {
  //       color: '#3a2069',
  //     },
  //   ],
  // },
  // {
  //   featureType: 'water',
  //   elementType: 'geometry.stroke',
  //   stylers: [
  //     {
  //       color: '#3a2069',
  //     },
  //   ],
  // },
  // {
  //   featureType: 'water',
  //   elementType: 'labels.text',
  //   stylers: [
  //     {
  //       color: '#ffffff',
  //     },
  //   ],
  // },
];
